import { getUserConfiguration } from 'owa-session-store';
import { lazySendAutomatedMessage, MessageDetails } from 'owa-automated-message';
import { searchDiagnosticsStore } from 'owa-search-diagnostics';
import { SearchRequestInstrumentation } from 'owa-search-service';
import { userVoiceSuggestionStore } from 'owa-uservoice';
import { UserVoiceSearchTeam } from '../components/SearchInContextFeedbackDialog';

export default async (userVoiceFeedbackTeam: UserVoiceSearchTeam) => {
    const sendAutomatedMessage = await lazySendAutomatedMessage.import();
    const messageDetails: MessageDetails = {
        subject: 'OWA 3S Query Feedback',
        message: buildMessage(),
        to:
            userVoiceFeedbackTeam == UserVoiceSearchTeam.CalendarSearch
                ? ['owasearchdog@microsoft.com']
                : ['owa3squeryfeedback@service.microsoft.com'],
        attachments: null,
    };

    const timeFormat = getUserConfiguration().UserOptions.TimeFormat;

    sendAutomatedMessage(messageDetails, timeFormat);
};

const buildMessage = () => {
    const feedbackCategories = userVoiceSuggestionStore.customFields
        .map(convertFeedbackCategoryToChecklistItem)
        .join('\n');

    const searchInstrumentationEntries = searchDiagnosticsStore.searchInstrumentationList.slice();

    searchInstrumentationEntries.forEach(instrumentation => {
        // Strip out PII data
        delete instrumentation.PIIData;

        // Add resource timing entries to top level of the object
        if (instrumentation.ResourceTimingEntry) {
            Object.keys(instrumentation.ResourceTimingEntry).forEach(key => {
                // Skip the rollup resource timing data
                if (key == 'cpv') {
                    return;
                }

                instrumentation[key] = instrumentation.ResourceTimingEntry[key];
            });
        }
        delete instrumentation.ResourceTimingEntry;
    });

    const searchInstrumentation = convertAllInstrumentationToTable(searchInstrumentationEntries);

    const message = `<h2>Categories</h2>${feedbackCategories} \n\n\n
        <h2>Verbatim</h2>${userVoiceSuggestionStore.message}\n\n\n
        <h2>Search History</h2>${searchInstrumentation.replace(/\n/g, '')}`;
    return message.replace(/\n/g, '<br />');
};

const convertFeedbackCategoryToChecklistItem = c =>
    `${c.Value ? String.fromCharCode(9745) : String.fromCharCode(9744)}&nbsp;${c.Name}`;

const convertAllInstrumentationToTable = (
    instrumentation: SearchRequestInstrumentation[]
): string =>
    instrumentation == null || instrumentation.length == 0
        ? null
        : `<table border="1">
            ${extractInstrumentationTableHeaders(instrumentation)}
            ${convertInstrumentationToTableRows(instrumentation)}
        </table>`;

const getDisplayFieldForKey = (key: string): string => {
    if (key == 'SearchQueryId') {
        return 'SearchConversationId';
    }

    return key;
};

const extractInstrumentationTableHeaders = (
    instrumentation: SearchRequestInstrumentation[]
): string =>
    `<thead><tr>
        ${Object.keys(instrumentation[0])
            .map(key => `<th>${getDisplayFieldForKey(key)}</th>`)
            .join('')}
    </tr></thead>`;

const convertInstrumentationToTableRows = (
    instrumentation: SearchRequestInstrumentation[]
): string =>
    instrumentation
        .map(
            e =>
                `<tr>
                    ${Object.keys(e)
                        .map(key => convertInstrumentationFieldToTableCell(e[key]))
                        .join('')}
                </tr>`
        )
        .join('');

const convertInstrumentationFieldToTableCell = (field: any): string => {
    if (field === undefined || field === null) {
        return '<td></td>';
    } else if (field instanceof Array) {
        return `<td>${field.join(',')}</td>`;
    } else if (field instanceof Date) {
        return `<td>${field.toISOString()}</td>`;
    } else {
        return `<td>${field.toString()}</td>`;
    }
};
